import Link from 'next/link';
import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Bar } from '../../atoms/Bar';
import { ReviewBarProps } from './ReviewBar.types';

export const ReviewBar = ({
  className,
  max,
  onFilterReviews,
  microcopy,
  review,
  value,
}: ReviewBarProps) => {
  return (
    <div className={c('flex w-full items-center text-sm', className)}>
      <span className="w-14 whitespace-nowrap font-normal tabular-nums tracking-[-0.028px] text-grey-900">
        {interpolateStringWithData(
          value !== 1 ? microcopy.ratings : microcopy.rating,
          { rating: value }
        )}
      </span>

      <Bar
        className="mx-3"
        value={value}
        max={max}
        ariaLabel={interpolateStringWithData(microcopy.ariaLabel, {
          review,
        })}
        renderInnerBar={review > 0}
      />

      {review === 0 ? (
        <span className="w-11 text-right tabular-nums text-grey-450">
          {review}
        </span>
      ) : (
        <Link
          className="w-11 text-right tabular-nums tracking-[-0.028px] text-blue no-underline"
          onClick={() => onFilterReviews(review)}
          aria-label={microcopy.ratingAriaLabel}
          href="#"
          title={microcopy.ratingAriaLabel}
        >
          {review}
        </Link>
      )}
    </div>
  );
};
